(() => {
  "use strict";
  const doc = document, root = doc.querySelector(".ita-hdr");
  if (!root) return;
  function hdLayout() {
    const nav = root.querySelector("#nav"); if (!nav) return;
    const kids = [...nav.children]; nav.style.paddingLeft = ""; root.classList.remove("hd-tight"); kids.forEach((k) => k.removeAttribute("data-hside"));
    if (!root.classList.contains("hd-2") || kids.length < 2 || innerWidth <= 1000 || !nav.getClientRects().length) return;
    const lg = root.querySelector(".hdr .ic.l"), ir = root.querySelector(".hdr .ic.r"), wr = root.querySelector(".hdr>.wrap"); if (!lg || !ir || !wr) return;
    const fit = () => {
      const lr = lg.getBoundingClientRect(), cx = lr.left + lr.width / 2, S = Math.round(lr.width + 56); root.style.setProperty("--hdS", S + "px");
      const ws = kids.map((k) => k.getBoundingClientRect().width), n = ws.length, L = wr.getBoundingClientRect().left + parseFloat(getComputedStyle(wr).paddingLeft), Rr = ir.getBoundingClientRect().left - 12; let best = null;
      for (let k = 1; k < n; k++) { const wl = ws.slice(0, k).reduce((a, b) => a + b, 0) + 2 * k, wrr = ws.slice(k).reduce((a, b) => a + b, 0) + 2 * (n - k), over = Math.max(0, L - (cx - S / 2 - wl)) + Math.max(0, cx + S / 2 + wrr - Rr), sc = over * 1000 + Math.abs(wl - wrr); if (!best || sc < best.sc) best = { k, sc, over }; }
      return { best, cx };
    };
    let f = fit(); if (f.best && f.best.over > 0) { root.classList.add("hd-tight"); f = fit(); } if (!f.best) return;
    kids.forEach((k, i) => { if (i >= f.best.k) k.dataset.hside = "r"; });
    const a = kids[f.best.k - 1].getBoundingClientRect().right, b = kids[f.best.k].getBoundingClientRect().left;
    nav.style.paddingLeft = Math.max(0, Math.round(f.cx - (a + b) / 2)) + "px";
  }
  let t = 0; const soon = () => { cancelAnimationFrame(t); t = requestAnimationFrame(hdLayout); };
  if (root.classList.contains("hd-2")) { try { new ResizeObserver(soon).observe(doc.body); } catch (e) { addEventListener("resize", soon); } if (doc.fonts) doc.fonts.ready.then(soon); soon(); }

  if (window.ITA) ITA.on("cart:updated", (e) => { const c = e.detail && e.detail.cart; if (!c) return; doc.querySelectorAll(".js-count").forEach((x) => { x.textContent = c.item_count; x.hidden = !c.item_count; }); });

  if (root.dataset.sticky === "1") {
    const hdr = root.querySelector(".hdr"); let on = false;
    const chk = () => { const y = scrollY > (root.offsetTop || 0) + 4; if (y !== on) { on = y; hdr.classList.toggle("is-stuck", y); } };
    addEventListener("scroll", chk, { passive: true }); chk();
  }
})();
